import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
import { Icon } from '../Icon/Icon';
import { PlainButton } from '../PlainButton/PlainButton';
import { Text } from '../Text/Text';
import { FlexContainer } from '../layout/FlexContainer';
const StyledEditableTag = styled('div', {
    width: 'fit-content',
    backgroundColor: staticColors.editableTagBackground,
    borderColor: staticColors.editableTagBorder,
    borderWidth: sizes.editableTag.borderWidth,
    borderStyle: 'solid',
    borderRadius: sizes.editableTag.borderRadius,
});
export const EditableTag = ({ children, testId, onDelete, }) => {
    const contentTestId = testId ? `${testId}-content` : undefined;
    const closeTestId = testId ? `${testId}-close` : undefined;
    return (_jsx(StyledEditableTag, { children: _jsxs(FlexContainer, { spacingVertical: '1/2', verticalAlign: 'center', spacingHorizontal: true, gap: true, children: [_jsx(Text, { variant: 's2', testId: contentTestId, children: children }), onDelete && (_jsx(PlainButton, { testId: closeTestId, onClick: onDelete, children: _jsx(Icon, { name: 'Close', size: 'small' }) }))] }) }));
};
